import { useParams } from 'react-router-dom'

import { FEATURE_MATRIX } from '@/config/features'
import { NotAllowedClarityPage } from '@/screens/error'
import KPIGoalPlanPage from '@/screens/targets/KpiGoalPlanPage'
import KPIPayoutPage from '@/screens/targets/KpiPayoutPage'
import { selectTenant, useAppSelector } from '@/store'

export default function TargetsPage() {
  const { id } = useParams()
  const tenant = useAppSelector(selectTenant)
  const features = FEATURE_MATRIX[tenant]

  if (id === 'kpi-payout') {
    return features.targetsKpiPayout ? (
      <KPIPayoutPage />
    ) : (
      <NotAllowedClarityPage pageTitle="KPI Payout" />
    )
  }
  if (id === 'goal-plans') {
    return features.targetsGoalPlans ? (
      <KPIGoalPlanPage />
    ) : (
      <NotAllowedClarityPage pageTitle="KPI Goal Plan" />
    )
  }
}
